import { Component, OnInit, OnChanges, OnDestroy, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalMenuService } from '../../projects';
import { TranslateService } from '@ngx-translate/core';
import { CountryNameService } from '../country.service';

@Component({
  selector: 'lib-global-menu',
  templateUrl: './global-menu.component.html',
  styleUrls: ['./global-menu.component.scss']
})

export class GlobalMenuComponent implements OnInit, OnChanges, OnDestroy {
  isShow = false;
  isExpanded: boolean;
  cActiveVal: boolean;
  nCount: number = 0;
  showLanguage: boolean;
  status: boolean = false;
  subscription: Subscription;
  subscriptionLang: Subscription;
  optionsLang: any = [];
  // triggerLang: string = '';
  @Output() languageChangeEvent = new EventEmitter();
  @Output() countryChangeEvent = new EventEmitter();
  @Output() navEvent = new EventEmitter();
  @Input() userType: string = '';
  @Output() menuEvent = new EventEmitter();
  @Input() profileName: string = '';
  @Input() fullName: string = '';
  showLang: string = '';
  userCountry: string = '';
  showClass: boolean = false;
  hasMultipleCountries: number = 0;
  @Input() initialLanguage: string = '';
  initialLanguageRadio: string = '';
  displayLang: string = '';
  @Input() notifyCount: any;
  @ViewChild('mySelect') mySelect;
  constructor(private _http: GlobalMenuService, public translate: TranslateService, public countryNameService: CountryNameService) { }

  ngOnInit() {
    this.subscription = this._http.showLanguageManager$.subscribe(data => {
      this.userCountry = localStorage.getItem('countryVal');
      if (!!JSON.parse(localStorage.getItem('langObject'))) {
        this.optionsLang = JSON.parse(localStorage.getItem('langObject'));
      }
      if (!!localStorage.getItem('Lang')) {
        this.initialLanguage = localStorage.getItem('Lang').toLowerCase();
        this.initialLanguageRadio = this.initialLanguage;

        if (this.initialLanguage.split("-").length == 1) {
          if (this.initialLanguage != 'en') {
            this.initialLanguage = this.initialLanguage.toLowerCase() + '-' + this.initialLanguage.toLowerCase();
            this.initialLanguageRadio = this.initialLanguage;
          }
        }
        this.selectLanguage(this.initialLanguage);
        this.displayLang = this.initialLanguage.split('-')[0];
      }
      this.showLanguage = data;
    });
    this.subscription = this._http.showCountryManager$.subscribe(data => {
      // this.showLanguage = data;
    });

    if (!!JSON.parse(localStorage.getItem('userObject'))) {
      this.hasMultipleCountries = JSON.parse(localStorage.getItem('userObject')).userCountries.length;
      this.userCountry = localStorage.getItem('countryVal');
    }
    if (!!JSON.parse(localStorage.getItem('langObject'))) {
      this.optionsLang = JSON.parse(localStorage.getItem('langObject'));
    }
    if (!!localStorage.getItem('Lang')) {
      this.initialLanguage = localStorage.getItem('Lang').toLowerCase();
      this.initialLanguageRadio = this.initialLanguage;

      if (this.initialLanguage.split("-").length == 1) {
        if (this.initialLanguage != 'en') {
          this.initialLanguage = this.initialLanguage.toLowerCase() + '-' + this.initialLanguage.toLowerCase();
          this.initialLanguageRadio = this.initialLanguage;
        }
      }
      this.selectLanguage(this.initialLanguage);
      this.displayLang = this.initialLanguage.split('-')[0];
    }
    this.subscriptionLang = this._http.getUpdatedLanguage$.subscribe(data => {
      if (data) {
        this.initialLanguage = data.toLowerCase();
        this.initialLanguageRadio = this.initialLanguage;
        if (this.initialLanguage.split("-").length == 1) {
          this.initialLanguage = this.initialLanguage + '-' + this.initialLanguage;
          this.initialLanguageRadio = this.initialLanguage;
        }
        this.selectLanguage(this.initialLanguage);
        this.displayLang = this.initialLanguage.split('-')[0];
      }
    });

  }

  getCountryName(countryCode) {
    return this.countryNameService.getCountryName(countryCode);
  }
  getLangName(lang) {
    if (lang) {
      var lan = lang.toLowerCase().split("-");
      if (lan.length > 1) {
        if (lan[0].toLowerCase() == lan[1].toLowerCase()) {
          return lan[0].toUpperCase();
        } else {
          return lang.toUpperCase();
        }
      } else {
        return lang.toUpperCase();
      }
    } else {
      lang = 'en';
      return lang.toUpperCase();
    }
  }

  selectLanguage(currentLang) {
    var currentLanguage = currentLang;
    var lan = currentLanguage.toLowerCase().split("-");
    if (lan.length > 1) {
      if (lan[0].toLowerCase() == lan[1].toLowerCase()) {
        localStorage.setItem('Lang', lan[0].toLowerCase());
        this.languageChangeEvent.emit(lan[0].toLowerCase());
        this.translate.use(lan[0].toLowerCase());
      } else {
        localStorage.setItem('Lang', currentLanguage.toLowerCase());
        this.languageChangeEvent.emit(currentLanguage.toLowerCase());
        this.translate.use(currentLanguage.toLowerCase());
      }
    } else {
      localStorage.setItem('Lang', currentLanguage.toLowerCase());
      this.languageChangeEvent.emit(currentLanguage.toLowerCase());
      this.translate.use(currentLanguage.toLowerCase());
    }
    this.showClass = false;
    if(this.mySelect) {
      this.mySelect.close();
    }
  }

  changeCountry() {
    this.mySelect.close();
    this.countryChangeEvent.emit();
  }
  capitalizeFirstLetter(str) {
    return str[0].toUpperCase() + str.slice(1);
  }
  ngOnChanges() {
    this.initialLanguage = this.initialLanguage.toLowerCase();
    this.initialLanguageRadio = this.initialLanguage;
    this.displayLang = this.initialLanguage.split('-')[0];
    this.nCount = this.notifyCount;
  }
  onChangeSideNav() {
    this.navEvent.emit({ event: "sidenavAction" });
  }
  onChangeApp() {
    this.menuEvent.emit({ event: "changeApp" });
    this.showClass = false;
  }
  onChangeAlert() {
    this.menuEvent.emit({ event: "changeAlert" });
    this.showClass = false;
  }
  onShowSearch() {
    this.menuEvent.emit({ event: "changeSearch" });
    this.showClass = false;
  }
  onShowLanguage() {
    this.menuEvent.emit({ event: "changeLanguage" });
  }
  onShowHelp() {
    this.menuEvent.emit({ event: "changeHelp" });
    this.showClass = false;
  }
  onShowContact() {
    this.menuEvent.emit({ event: "changeContact" });
    this.showClass = false;
  }
  onChangeProfile() {
    this.menuEvent.emit({ event: "changeProfile" });
    this.showClass = false;
  }
  addClass() {
    this.showClass = true;
  }
  consentView() {
    this.menuEvent.emit({ event: "showConcent" });
  }
  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
    if (this.subscriptionLang)
      this.subscriptionLang.unsubscribe();
    this.showClass = false;
  }
}
